import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface } from '@src/components/pl-base-widget'

import { DisclaimerWidgetComponent } from './disclaimer-widget.component'

import type { DisclaimerWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * DISCLAIMER widget — legal disclaimers for products (e.g. FDA disclaimers for health/supplement products).
 *
 * Reads disclaimer text from the widget's proto data and renders it safely using HTML sanitization.
 * Renders nothing if no disclaimer text is provided.
 */
export const DisclaimerWidget: PLTypedWidgetInterface<
  DisclaimerWidgetData,
  WidgetType.DISCLAIMER
> = {
  id: WidgetType.DISCLAIMER,
  errorBoundary: PLBaseErrorBoundary,
  render: DisclaimerWidgetComponent,
}
